import { useState } from 'react'
import { Autocomplete, Box, ListSubheader, TextField } from '@mui/material'

import { colours } from '../settings/settings'

// bugfix for Safari on MacBook
const renderGroup = ({ key, group, children }) => (
  <li key={key}>
    <ListSubheader component='div' sx={{ top: -8 }}>
      {group}
    </ListSubheader>
    <Box
      component='ul'
      sx={{ padding: 0, '& .MuiAutocomplete-option': { paddingLeft: 3 } }}
    >
      {children}
    </Box>
  </li>
)

const AutoComplete = ({
  id,
  value,
  blurOnSelect = true,
  clearOnBlur = true,
  clearOnEscape = true,
  disabled = false,
  disableCloseOnSelect = true,
  freeSolo = false,
  fullWidth = true,
  multiple = false,
  openable = true,
  optional = false,
  readOnly = false,
  showPopupIcon = true,
  align = 'left',
  size = 'medium',
  label = '',
  variant = 'filled',
  options = [],
  groupBy = () => {},
  getOptionLabel = option => option,
  getOptionDisabled = () => false,
  isOptionEqualToValue = (option, value) => {
    if (!!option?.id && !!value?.id) return option.id === value.id
    return option === value
  },
  onChange = () => {},
  onInputChange = () => {},
  noOptionsText = 'Nessuna opzione',
  clearText = 'Cancella',
  closeText = 'Chiudi',
  openText = 'Apri',
  mode,
  helperText = '',
  errorText = '',
  errorFunc = value => mode === 'update' && !value && !optional,
}) => {
  const [hasBlurred, setHasBlurred] = useState(false)

  const isReadOnly = readOnly || mode === 'view'

  const emptyValue = multiple ? [] : null

  const isError = hasBlurred && errorFunc(value)

  return (
    <Autocomplete
      id={id}
      blurOnSelect={!!blurOnSelect}
      clearOnBlur={!!clearOnBlur}
      clearOnEscape={!!clearOnEscape}
      disabled={!!disabled}
      disableCloseOnSelect={!!disableCloseOnSelect}
      forcePopupIcon={!!showPopupIcon}
      freeSolo={!!freeSolo}
      fullWidth={!!fullWidth}
      multiple={!!multiple}
      open={!!openable ? undefined : false}
      readOnly={!!isReadOnly}
      size={size}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          error={!!isError}
          helperText={(!!isError && errorText) || helperText}
          slotProps={{
            input: {
              ...params.InputProps,
              style: {
                backgroundColor:
                  (!!disabled && 'transparent') ||
                  (!!isError && colours.redError),
              },
            },
            htmlInput: { ...params.inputProps, style: { textAlign: align } },
          }}
        />
      )}
      value={value || emptyValue}
      options={options}
      groupBy={groupBy}
      renderGroup={renderGroup}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={getOptionDisabled}
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={(_, value) => onChange(value)}
      onInputChange={onInputChange}
      onBlur={() => setHasBlurred(true)}
      noOptionsText={noOptionsText}
      clearText={clearText}
      closeText={closeText}
      openText={openText}
    />
  )
}

export default AutoComplete
